/**
 * Processes media resource URL to ensure proper formatting
 * @param url The original URL from the resource
 * @param cacheTag Optional cache tag to append to the URL
 * @returns Properly formatted URL with cache tag if provided
 */
export const getMediaUrl = (url: string | null | undefined, cacheTag?: string | null): string => {
  if (!url) return ''

  let processedCacheTag = cacheTag
  if (processedCacheTag && processedCacheTag !== '') {
    processedCacheTag = encodeURIComponent(processedCacheTag)
  }

  // Check if URL already has http/https protocol (external URL)
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return processedCacheTag ? `${url}?${processedCacheTag}` : url
  }

  // For relative URLs (same-origin media), keep them relative
  // This ensures they work on any deployment (staging, preview, production)
  return processedCacheTag ? `${url}?${processedCacheTag}` : url
}
